import { useState, useEffect } from "react";
import {  Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import BaseParagraph from "../baseComponents/baseParagraph";
import React from "react";
import useBootstrap from "../customHooks/useBootstrap";



const EnlargeOnClick = ({ children, modalTitle = "", proportion =  60}) => {

  const {trashold, classes} = useBootstrap();
  const [orientation, setOrientation] = useState();

  const [isEnlarged, setIsEnlarged] = useState(false);

  const toogleEnalrged = () => {
    setIsEnlarged((prevstate) => !prevstate);
  };

  const closeEnlarged = () => {
    setIsEnlarged(false);
  };

  useEffect(() => {
    if (isEnlarged === true) {
      setTimeout(() => {
        const myBardodeSvg = document.querySelectorAll(
          ".enlargeDiv .myBarcode > svg"
        );
        myBardodeSvg.forEach((svg) => {
          svg.setAttribute("width", "100%");
          svg.setAttribute("height", "100%");
          //svg.setAttribute("fill", "100%");
        });
      }, 0);
    }
  }, [isEnlarged]);

  function handleMediaQueryChange(mediaQueryList) {
    if (mediaQueryList.matches) {
      // Media query matches
      setOrientation("portrait");
    } else {
      // Media query doesn't match
      setOrientation("landscape");
    }
  }

  const mediaQuery = window.matchMedia("(orientation: portrait)");

  useEffect(() => {
    handleMediaQueryChange(mediaQuery);
    mediaQuery.addEventListener("change", handleMediaQueryChange);

    return ()=> {
      mediaQuery.removeEventListener("change", handleMediaQueryChange);
    };
  }, []);




  return (
    <span
      onClick={() => {
        setIsEnlarged((prevstate) => !prevstate);
      }}
      style={{ cursor: "zoom-in" }}
    >
      <Modal fullscreen isOpen={isEnlarged} toggle={toogleEnalrged}>
        <ModalHeader toggle={toogleEnalrged}>
          {modalTitle && <BaseParagraph>{modalTitle}</BaseParagraph>}
        </ModalHeader>
        <ModalBody>
          <div
            onClick={closeEnlarged}
            className="enlargeDiv"
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              overflowX: "hidden",

              position: "relative",
            }}
          >
            <div className={`${classes.onOrAboveTrashold.show(true)}`}>
              {React.Children.map(children, (child) => {
                const originalStyle = child.props.style ?? {};
                return (
                  <>
                    {React.cloneElement(child, {
                      style: {
                        ...originalStyle,
                        width: `${proportion}vw`,
                        height: `${proportion}vh`,
                      },
                    })}
                  </>
                );
              })}
            </div>
            <div
              className={`${classes.onOrAboveTrashold.show(false)}`}
              style={{}}
            >
              {React.Children.map(children, (child) => {
                const originalStyle = child.props.style ?? {};
                return (
                  <>
                    {React.cloneElement(child, {
                      style: {
                        ...originalStyle,
                        width: orientation === `portrait` ? `${proportion}vh` : `${proportion}vw`,
                        height:  orientation === `portrait` ? `${proportion}vw` : `${proportion}vh`,
                        transform: orientation === `portrait` ? `rotate(90deg)` : `none`,
                      },
                    })}
                  </>
                );
              })}
            </div>
          </div>
        </ModalBody>
      </Modal>
      {children}
    </span>
  );
};

export default EnlargeOnClick;
